export default function(obj, key) {
  return obj ? obj[key] !== undefined && key in obj && obj[key] !== "" : false
}

export const hasOwnProperty = (obj, key) => {
  return obj.hasOwnProperty(key)
}
